import { createSelector } from 'reselect';
import { getHasThemePresetsAccessScope } from './authSelectors';
import { getThemePath } from './themeSelectors';
import { getActiveThemePresetId } from './themeSettingsSelectors';
import { getIsPresetPanelOpen } from './appSelectors';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { PRESET_TYPES } from '../constants/Presets';
import { stateSelectorSwitcher } from '../utils/selectorUtils';
export const getHasThemePresetsAccess = (state, props) => {
  const isScopedForPresets = getHasThemePresetsAccessScope(state);
  const themePath = getThemePath(state) || (props === null || props === void 0 ? void 0 : props.themePath);
  return isScopedForPresets && themePath === '@hubspot/elevate' // TODO: remove this once other themes support presets
  ;
};
const getPresets = state => stateSelectorSwitcher(state, 'presets');
export const getPresetsById = state => getPresets(state).presetsById;
export const getPresetById = (state, id) => {
  return getPresetsById(state)[id];
};
export const getPresetsRequestStatus = state => getPresets(state).requestStatus;
export const getFetchActiveThemePresetBufferRequestStatus = state => getPresets(state).fetchActiveThemePresetBufferRequestStatus;
export const getThemePresetIdToPreview = state => getPresets(state).selectedThemePresetId;
export const getSelectedThemePresetId = state => {
  const isPresetPanelOpen = getIsPresetPanelOpen(state);
  const activeThemePresetId = getActiveThemePresetId(state);
  const themePresetIdToPreview = getThemePresetIdToPreview(state);
  return isPresetPanelOpen ? themePresetIdToPreview : activeThemePresetId;
};
export const getSelectedThemePreset = state => {
  const selectedThemePresetId = getSelectedThemePresetId(state);
  return selectedThemePresetId !== undefined ? getPresetById(state, selectedThemePresetId) : {
    type: PRESET_TYPES.EMPTY
  };
};

// Use createSelector to memoize getting presets list rather than creating a new reference
// which allows presets to be used in dependency array without triggering change on every render
export const getPresetsList = createSelector([getPresetsById], presetsById => Object.values(presetsById));
export const getActiveThemePreset = state => {
  const activeThemePresetId = getActiveThemePresetId(state);
  return activeThemePresetId !== undefined ? getPresetById(state, activeThemePresetId) : undefined;
};
export const getActiveThemePresetType = state => {
  const activeThemePreset = getActiveThemePreset(state);
  return (activeThemePreset === null || activeThemePreset === void 0 ? void 0 : activeThemePreset.type) || PRESET_TYPES.EMPTY;
};
export const getActiveThemePresetStyles = state => {
  const activeThemePreset = getActiveThemePreset(state);
  return activeThemePreset === null || activeThemePreset === void 0 ? void 0 : activeThemePreset.styles;
};
export const getIgnoreUserThemeOverrides = state => getPresets(state).ignoreUserThemeOverrides;
export const getActiveThemePresetObjectId = state => getPresets(state).activeThemePresetObjectId;
export const getHasLoadedPresets = state => getPresetsRequestStatus(state) === RequestStatusTypes.SUCCEEDED && getFetchActiveThemePresetBufferRequestStatus(state) === RequestStatusTypes.SUCCEEDED;
export const getIsLoadingPresets = state => getPresetsRequestStatus(state) === RequestStatusTypes.PENDING || getFetchActiveThemePresetBufferRequestStatus(state) === RequestStatusTypes.PENDING;
export const getPublishedActiveThemePresetId = state => getPresets(state).publishedActiveThemePresetId;